export interface ILineItem {
	description: string;
	key: string;
	label: string;
	value: number;
}

interface IInternalLineItem {
	key: string;
	li: HTMLLIElement;
}
export default class Summary {
	dynamicChildren: Array<IInternalLineItem>;
	summaryContainer: HTMLDivElement;
	summaryList: HTMLUListElement;

	constructor() {
		this.dynamicChildren = [];
		this.summaryContainer = document.querySelector(
			".exto-product-summary",
		) as HTMLDivElement;
		this.summaryList = this.summaryContainer.querySelector(
			"ul",
		) as HTMLUListElement;
	}

	/** @param newLineItem */
	public addLineItem(newLineItem: ILineItem) {
		const { description, key, label, value } = newLineItem;
		const price = value !== 0 ? value.toFixed(2) : "-";
		this.dynamicChildren.push({
			key,
			li: this.createLI(label, description, price),
		});
		this.renderChildren();
	}

	public removeAllLineItems() {
		this.clearChildren();
		this.dynamicChildren = [];
		this.renderChildren();
	}

	/** @param key */
	public removeLineItem(key: string) {
		this.clearChildren();
		this.dynamicChildren = this.dynamicChildren.filter((i) => i.key !== key);
		this.renderChildren();
	}

	private clearChildren() {
		for (const item of this.dynamicChildren) {
			if (this.summaryList.contains(item.li)) {
				this.summaryList.removeChild(item.li);
			}
		}
	}

	/**
	 * @param col1
	 * @param col2
	 * @param col3
	 */
	private createLI(col1: string, col2: string, col3: string): HTMLLIElement {
		const createSpan = (value: string) => {
			const newSpan = document.createElement("span");
			newSpan.textContent = value;
			return newSpan;
		};
		const newItem = document.createElement("li");
		newItem.append(createSpan(col1));
		newItem.append(createSpan(col2));
		newItem.append(createSpan(col3));

		return newItem;
	}

	private renderChildren() {
		this.clearChildren();
		for (const item of this.dynamicChildren) {
			this.summaryList.append(item.li);
		}
	}
}
